import { common_process_type, post_process_type, response_type, response_type_internal } from '../interfaces';

// ██╗  ██╗████████╗████████╗██████╗     ██████╗ ███████╗ ██████╗ ██╗   ██╗███████╗███████╗████████╗
// ██║  ██║╚══██╔══╝╚══██╔══╝██╔══██╗    ██╔══██╗██╔════╝██╔═══██╗██║   ██║██╔════╝██╔════╝╚══██╔══╝
// ███████║   ██║      ██║   ██████╔╝    ██████╔╝█████╗  ██║   ██║██║   ██║█████╗  ███████╗   ██║
// ██╔══██║   ██║      ██║   ██╔═══╝     ██╔══██╗██╔══╝  ██║▄▄ ██║██║   ██║██╔══╝  ╚════██║   ██║
// ██║  ██║   ██║      ██║   ██║         ██║  ██║███████╗╚██████╔╝╚██████╔╝███████╗███████║   ██║
// ╚═╝  ╚═╝   ╚═╝      ╚═╝   ╚═╝         ╚═╝  ╚═╝╚══════╝ ╚══▀▀═╝  ╚═════╝ ╚══════╝╚══════╝   ╚═╝
//                      H       T       T       P           請          求

declare const common_process: common_process_type;
declare const post_process: post_process_type;

/**
 * @param {string} url
 * @param {number} method_id
 * @param {string} [body]
 * @param {string} [kind]
 * @param {string} [unit]
 * @param {1} [is_string]
 * @return {*}  {Promise<any>}
 */
export default function http_request_worker(
  url: string,
  method_id: number,
  body?: string,
  kind?: string,
  unit?: string,
  is_string?: 1,
  content_type?: string,
  no_sorting?: 1,
  no_underlined_key?: 1
): Promise<any> {
  const method: string = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'][method_id];
  let response_code: number;
  return fetch(
    `${origin}${url}`,
    Object.assign(
      {
        method,
        headers: {
          'Content-Type': content_type ?? 'application/json; charset=utf-8',
          Accept: 'application/json',
          credentials: 'include'
        }
      },
      body && method_id ? { body } : {}
    )
  )
    .then(
      (response: Body): Promise<string> => {
        response_code = (response as any).status;
        return response.text();
      }
    )
    .then((response_text: string) => {
      try {
        let response: response_type = JSON.parse(response_text);
        const process_response = (response: response_type_internal | undefined) => {
          if (response) {
            if (response_code >= 400) {
              response.code = response_code;
            } else if (typeof response.status === 'number') response.code = response.status;

            response.kind = kind;
          }
          return response;
        };

        response = Array.isArray(response)
          ? response.map((response_each: response_type_internal | undefined) => process_response(response_each))
          : process_response(response);

        return new Promise((resolve) => {
          response = response ? common_process(response, no_sorting, no_underlined_key) : response;
          // 處理後將結果回傳給主線程
          if (post_process) {
            (Array.isArray(post_process)
              ? Promise.all(
                  post_process.map(
                    (post_process_each) =>
                      new Promise((resolve_2: (value?: unknown) => void) => {
                        post_process_each?.({
                          response,
                          unit,
                          resolve: resolve_2
                        });
                      })
                  )
                )
              : new Promise((resolve_2: (value?: unknown) => void) => {
                  post_process({
                    response,
                    unit,
                    resolve: resolve_2
                  });
                })
            )
              .then((result: unknown) => {
                resolve({
                  original_response: response,
                  result
                });
              })
              .catch((err: any) => {
                console.error(err);
                resolve({ result: response });
              });
          }
          // 不處理，將結果回傳給主線程
          else resolve({ result: response });
        });
      } catch {
        return new Promise((resolve: (value: unknown) => void, reject: (reason?: any) => void) => {
          response_code < 400 ? resolve(is_string ? { result: response_text } : {}) : reject({ code: response_code, message: response_text });
        });
      }
    })
    .catch((err) => {
      console.error(err);

      // 處理後將結果回傳給主線程
      return err;
    });
}
